module.exports = __webpack_public_path__ + "static/media/7S.8343d3ef.svg";